module.exports = __webpack_public_path__ + "static/media/close-button-black.46ec67a8.svg";